import React from 'react';

interface TrendBadgeProps {
  value: number;
}

export const TrendBadge: React.FC<TrendBadgeProps> = ({ value }) => {
  const isPositive = value > 0;
  const isNegative = value < 0;

  // Format to exactly 2 decimal places (e.g., 2.50).
  const formattedValue = Math.abs(value).toFixed(2) + '%';

  return (
    <span
      className={`inline-flex items-center font-medium ${
        isPositive
          ? 'text-emerald-600 dark:text-emerald-400'
          : isNegative
            ? 'text-red-600 dark:text-red-400'
            : 'text-gray-500 dark:text-gray-400'
      }`}
    >
      {isPositive && '+'}
      {isNegative && '-'}
      {formattedValue}
    </span>
  );
};
